import { connect } from 'react-redux';
import { AppState } from '../../../../../../types/store';
import { actions as modalActions } from '@wix/da-shared-react/pkg/Modals';
import {
  getProfileOwner,
  getProfileOwnerUser,
  isCurrentUserProfileOwner,
} from '../../../../../selectors/users';
import {
  fetchProfileOwnerGiveState,
  fetchProfileOwnerGiveStateSuccess,
} from '../../../../../actions/profileOwner';

export default connect(
  (state: AppState) => ({
    giveState: getProfileOwner(state).giveState,
    profileOwnerUser: getProfileOwnerUser(state),
    isOwner: isCurrentUserProfileOwner(state),
  }),
  dispatch => ({
    pushBadgeModal: (name, userId, title, onBadgeSent) =>
      dispatch(modalActions.pushBadgeModal(name, userId, title, onBadgeSent)),
    pushPointsModal: (userId, title) =>
      dispatch(modalActions.pushPointsModal(userId, title)),
    initGiveState: () => dispatch(fetchProfileOwnerGiveState()),
    onLlamaBadgeSent: () =>
      dispatch(fetchProfileOwnerGiveStateSuccess({ canBeGivenLlama: false })),
    onCakeBadgeSent: () =>
      dispatch(fetchProfileOwnerGiveStateSuccess({ canBeGivenCake: false })),
  })
);
